<template>
  <div>
    <div v-for="chart of charts" :key="chart.options.chart.id" class="mb-3">
      <apexchart
        width="100%"
        type="line"
        :options="chart.options"
        :series="chart.series"
      ></apexchart>
    </div>
    <table
      class="table table-striped table-hover"
      v-for="(table, key) of tables"
      :key="key"
    >
      <thead>
        <tr>
          <th colspan="2">{{ table.title }}</th>
        </tr>
        <tr>
          <th>თარიღი</th>
          <th>მნიშვნელობა</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item of table.items" :key="item.date">
          <td>
            <small>
              {{ item.date | moment("DD MMM YYYY HH:mm") }}
            </small>
          </td>
          <td>
            <small>{{ item.value }}</small>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    patientId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      charts: {},
      tables: {}
    };
  },
  computed: {
    ...mapGetters({
      patientLogTypes: "patientLogType/patientLogTypes",
      authLocale: "auth/locale"
    })
  },
  watch: {
    patientLogTypes: {
      deep: true,
      immediate: true,
      handler(patientLogTypes) {
        for (const plt of patientLogTypes) {
          if (plt.items[0].value_type === "url") {
            this.fetchTable(plt.items[0].id);
          } else {
            this.fetchChart(plt.items[0].id);
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setError: "alert/setError"
    }),
    async fetchTable(type) {
      const logs = await this.fetch(type);
      if (logs.length === 0) {
        return;
      }
      let group = logs[0].type_group_id;
      let title = "";
      if (logs[0].type_group_name) {
        title = logs[0].type_group_name[this.authLocale];
      }
      if (!group) {
        group = logs[0].items[0].type;
        title = logs[0].items[0].name[this.authLocale];
      }
      const table = {
        title: title,
        items: []
      };
      for (const i in logs[0].items) {
        for (const log of logs) {
          table.items.unshift({
            value: log.items[i].value,
            date: log.items[i].created_at
          });
        }
      }
      this.$set(this.tables, group, table);
    },
    async fetchChart(type) {
      try {
        const logs = await this.fetch(type);
        if (logs.length === 0) {
          return;
        }
        let group = logs[0].type_group_id;
        let title = "";
        if (logs[0].type_group_name) {
          title = logs[0].type_group_name[this.authLocale];
        }
        if (!group) {
          group = logs[0].items[0].type;
          title = logs[0].items[0].name[this.authLocale];
        }
        const xaxis = [];
        for (const log of logs) {
          xaxis.unshift(
            this.$moment(log.items[0].created_at).format("DD MMM YYYY HH:mm")
          );
        }
        let chart = {
          options: {
            chart: {
              id: group,
              toolbar: {
                show: false
              }
            },
            dataLabels: {
              enabled: true
            },
            title: {
              text: title,
              align: "left"
            },
            xaxis: {
              categories: xaxis
            }
          },
          series: []
        };
        if (this.charts[group]) {
          chart = this.charts[group];
        }
        const types = [];
        for (const i of logs[0].items) {
          types.push({ type: i.type, name: i.name });
        }
        for (const t of types) {
          const data = [];
          for (const log of logs) {
            for (const i of log.items) {
              if (i.type !== t.type) {
                continue;
              }
              data.unshift(i.value);
            }
          }
          chart.series.push({
            name: t.name[this.authLocale],
            data: data
          });
        }

        this.$set(this.charts, group, chart);
      } catch (err) {
        this.setError(err);
      }
    },
    async fetch(type) {
      try {
        const params = {
          offset: 0,
          limit: 100,
          type: type
        };
        const response = await this.axios.get(
          `/api/patients/${this.patientId}/logs`,
          { params }
        );
        return response.data.data;
      } catch (err) {
        this.setError(err);
      }
    }
  }
};
</script>
